import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 15.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 4v12h14.83L20 17.17V4H4zm13 7h-4v4h-2v-4H7V9h4V5h2v4h4v2z",
  opacity: ".3"
})), 'AddCommentTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddCommentTwoTone.js
// module id = 1887
// module chunks = 2